// ###############################################################################################################
// Equalizer
function Equalizer() {
    var maxHeight = 0;
    var maxWidth = 0;

    // Equal Them Group
    var eqGroup = $(".equal-them-group");

    $(eqGroup).each(function () {
        var eqGroupItem = this;
        var eqGroupDataArray = $(this).data("eq-group").split("|");

        $(eqGroupDataArray).each(function (index, item) {
            // Reset the maximum heights and widths
            maxHeight = 0;
            maxWidth = 0;

            var children = $(eqGroupItem).find(".equal-me-" + item);

            // Get the array with exlusion sizes
            var excludeOnArray = $(children).data("eq-exclude-on");
            excludeOnArray = excludeOnArray == undefined ? "" : excludeOnArray;
            var equalizerIsActive = excludeOnArray ==  "" ? true : EqualizerActive(excludeOnArray);

            // If there is no direction set to height by default
            var eqDirection = $(children).data("eq-direction");
            eqDirection = eqDirection == "" || eqDirection == undefined ? "height" : eqDirection;

            // Set the conditionals for the height and width elements
            var heightActive = eqDirection == "height" || eqDirection == "both" ? true : false;
            var widthActive = eqDirection == "width" || eqDirection == "both" ? true : false;

            // Set Heights
            if (heightActive) {
                $(children).height("auto");
                if (equalizerIsActive) {
                    $(children).each(function () {
                        var height = $(this).height();
                        if (maxHeight < height) {
                            maxHeight = height;
                        }
                    });
                    $(children).height(maxHeight + 1);
                }
            }

            // Set Widths
            if (widthActive) {
                $(children).width("auto");
                if (equalizerIsActive) {
                    $(children).each(function () {
                        var width = $(this).width();
                        if (maxWidth < width) {
                            maxWidth = width;
                        }
                    });
                    $(children).width(maxWidth + 1);
                }
            }
        });

    });
}

// This works out if any of the exclusion sizes are in range of the current window width
function EqualizerActive(exclusionSizes) {
    var equalizerIsActive = true;
    var windowWidth = jQuery(window).width();
    var exclusionArray = exclusionSizes.split(",");

    $(exclusionArray).each(function (index, exclusionRange) {
        var exclusionRangeArray = exclusionSizes.split("-");
        if (exclusionRangeArray[0] < windowWidth && exclusionRangeArray[1] > windowWidth)
        {
            equalizerIsActive = false;
        }
    });

    return equalizerIsActive;
}

$(function () {
    // ###############################################################################################################
    // Chrome Timeout Functions
    setTimeout(Equalizer, 200); // Fire the Equalizer for the inital load

    // ###############################################################################################################
    // Resizing Functions
    $(window).resize(function () {
        Equalizer();
    });
});